import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-his-archi-stu-society',
  templateUrl: './his-archi-stu-society.component.html',
  styleUrls: ['./his-archi-stu-society.component.scss']
})
export class HisArchiStuSocietyComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('History and Archaeology Students Society');
  }

}
